import React from 'react';
import cx from 'classnames';
import Grid from './../../Grid/';

const FormGrid = ({ className, ...otherProps }) => (
  <Grid className={cx('grid--form', className)} {...otherProps} />
);
FormGrid.displayName = 'FormGrid';

export default FormGrid;



// WEBPACK FOOTER //
// ./src/components/Forms/FormGrid/index.js